import React, { useMemo, useState } from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Box } from '@material-ui/core';
import ViewSamples from './ViewSamples';
import SampleDataViewCard from './SampleDataViewCard';
import { groupBy } from 'lodash';

const SampleEditView = ({ pins, samplePoints = [], samplesData, handleAction, handleSampleData, dropDownOptions }) => {
  const [expandedSampleId, setExpandedSampleId] = useState(null);

  const mergedSamples = useMemo(() => {
    return pins
      .filter(pin => pin.mapLabel?.toLowerCase().startsWith('sample point')) // ✅ Only valid sample points
      .map(pin => {
        const sampleName = pin.mapLabel;

        const points = samplePoints.filter(p => p.sampleName === sampleName);
        const sampleDataEntry = Array.isArray(samplesData)
          ? samplesData.find(d => d.sampleName === sampleName)
          : samplesData?.sampleName === sampleName
          ? samplesData
          : null;

        return {
          id: pin.id,
          sampleName,
          mapColor: pin.hexColor || 'gray',
          samplePoints: points,
          ...(sampleDataEntry || {}), // Merges avgHeight, quality, dbh, etc.
        };
      });
  }, [pins, samplePoints, samplesData]);

  const handleAccordionToggle = sampleId => {
    setExpandedSampleId(prev => (prev === sampleId ? null : sampleId));
  };

  return (
    <Box width="100%" maxWidth={600} marginLeft={2}>
      <Box sx={{ marginBottom: 4 }}>
        {mergedSamples?.map(sample => (
          <Accordion
            key={sample.id}
            expanded={expandedSampleId === sample.id}
            onChange={() => handleAccordionToggle(sample.id)}>
            <AccordionSummary>
              <Box display="flex" flexDirection="column" width="100%">
                <Typography fontWeight="bold">{sample.sampleName}</Typography>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              <Box display="flex" flexDirection="column" gap={3}>
                {/* Sample Data View */}
                <SampleDataViewCard
                  samplePoints={sample.samplePoints}
                  samplesData={sample}
                  handleSampleData={handleSampleData}
                />

                {/* Samples View */}
                <ViewSamples
                  samples={sample.samplePoints}
                  sampleName={sample.sampleName}
                  dropDownOptions={dropDownOptions}
                  handleAction={handleAction}
                />
              </Box>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Box>
  );
};

export default SampleEditView;
